import React from 'react'
import SVG from 'react-inlinesvg'

interface Props {
  className?: string
}

export const ErrorCircle = ({className}: Props) => {
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="81.756" height="81.756" viewBox="0 0 81.756 81.756">
    <g id="Group_4824" data-name="Group 4824" transform="translate(-911.318 -351)">
      <g id="Group_3676" data-name="Group 3676" transform="translate(911.318 351)">
        <circle id="Ellipse_738" data-name="Ellipse 738" cx="40.878" cy="40.878" r="40.878" fill="#fceeed"/>
      </g>
      <g id="exclamation" transform="translate(933.132 372.813)">
        <path id="Path_11136" data-name="Path 11136" d="M19.064,0A19.064,19.064,0,1,0,38.129,19.064,19.064,19.064,0,0,0,19.064,0Zm0,33.363a14.3,14.3,0,1,1,14.3-14.3A14.3,14.3,0,0,1,19.064,33.363Z" fill="#ff3040"/>
        <path id="Path_11137" data-name="Path 11137" d="M226.383,124.5a2.383,2.383,0,0,0,2.383-2.383V110.991a2.383,2.383,0,0,0-4.766,0v11.121A2.383,2.383,0,0,0,226.383,124.5Z" transform="translate(-207.319 -100.52)" fill="#ff3040"/>
        <circle id="Ellipse_852" data-name="Ellipse 852" cx="2.383" cy="2.383" r="2.383" transform="translate(16.689 25.419)" fill="#ff3040"/>
      </g>
    </g>
  </svg>`
  return <SVG className={className} src={svgIcon} />
}
